<div class="customer-details">
    <h1>{{lidDetails.FirstName}}</h1>
    <h3>{{'CUSTOMERS.CUSTOMER_DETAILS'|translate}}:</h3>
    <div>
        <div class="row-details row">
            <span class="title">{{'CUSTOMERS.FIRST_WINS_CREATED_DATE'|translate}}</span>
            <span class="value">{{lidDetails.FirstWinCreatedDate | date:'dd/MM/yyyy'}}</span>
        </div>
        <div class="row-details row"><span class="title">{{'CUSTOMERS.PHONE'|translate}}</span>
            <span class="value">{{lidDetails.Phone}}</span>
        </div>
        <div class="row-details row"><span class="title">{{'CUSTOMERS.EMAIL'|translate}}</span>
            <span class="value">{{lidDetails.Email}}</span>
        </div>
        <div class="row-details row"><span class="title">{{'CUSTOMERS.ID'|translate}}</span>
            <span class="value">{{lidDetails.CustomerId}}</span>
        </div>
    </div>
    <h3>{{'CUSTOMERS.AWARDS'|translate}}:</h3>
</div>
<ng-template #actions let-rowData>
    <button *ngIf="rowData['Status']===statusType.notRealized" class="command-button full full-width"
        (click)="confirmUseWin(rowData['CouponNum'],rowData['CouponName'])">{{'CUSTOMERS.IMPLEMENT'|translate}}</button>
</ng-template>
<app-readonly-table class="dialog-table" #dt [columns]="couponsColumns" [selectionMode]="null" [itemsSource$]="coupons$"
    [isFilterable]="false" [isLoadLazy]="true" [paginator]="false">
</app-readonly-table>